import Grid from '@mui/material/Grid';
import { observer } from 'mobx-react-lite';
import { Button, CheckboxField, HintBox } from '../../../../components';
import { useAccount, useIsAdmin } from '../../../../store';
import { ProductHelp } from '../../../../store/constants/help';
import Product from '../../store/Product';
import FileBrowserDialog from './components/browser/FileBrowserDialog';
import VersionView from './components/VersionView';

export default observer(function FilesPanel({ product }: { product: Product }) {
  const { hasCdnEnabled: isCdnSettingsAvailable, configurations } =
    useAccount();
  const isAdmin = useIsAdmin({ mode: 'any' });
  const isUseCdnToggleVisible =
    isCdnSettingsAvailable && (!configurations.managedStorage || isAdmin);

  return (
    <>
      {isUseCdnToggleVisible && (
        <CheckboxField
          helperText={ProductHelp.enhancedCdn.text}
          label={ProductHelp.enhancedCdn.label}
          name="useCdn"
          onChange={product.handleChange}
          sx={{ mb: 2 }}
          value={product.useCdn}
        />
      )}

      <Grid container spacing={6}>
        <Grid item xs={8}>
          {product.versions.items.map((version) => (
            <VersionView key={version.id} product={product} version={version} />
          ))}

          {product.versions.allowsAddVersion && (
            <Button
              icon="plus"
              onClick={product.versions.addEmptyVersion}
              size="small"
              sx={{ mt: 2 }}
              type="primary"
            >
              Add new version
            </Button>
          )}
        </Grid>

        <Grid item xs={4}>
          <HintBox help={ProductHelp.files} />
        </Grid>

        <FileBrowserDialog />
      </Grid>
    </>
  );
});
